<!-- eslint-disable max-len -->
<template>
  <datepicker :class="'flex-grow-1'"
    format="MM/dd/yyyy"
    input-class="form-control bg-white col-12"
    :use-utc="false"
    :disabled-dates="schema.disabledDates"
    :clear-button="schema.clearButton"
    v-model="value"
    :bootstrap-styling="true"
    @selected=setValue>
  </datepicker>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'CustomDatePicker',
  mixins: [abstractField],
  components: {
    Datepicker,
  },
  methods: {
    setValue(selectedDate) {
      this.value = selectedDate;
    },
  },
};
</script>
